import { useQuery as n } from "./contact-channels42.js";
import { useContactChannelsContext as r } from "./contact-channels19.js";
import { getChannelsData as a } from "./contact-channels75.js";
const m = (e = !0) => {
  const { locale: t } = r();
  return n({
    queryKey: ["channels-data"],
    queryFn: () => a(t),
    staleTime: 1 / 0,
    gcTime: 1 / 0,
    retry: 3,
    enabled: e
  });
};
export {
  m as useChannelsData
};
//# sourceMappingURL=contact-channels44.js.map
